const ApiUrl = `http://domecqapi.trebolbit.com/api/`;
// export const PageWebUrl = "http://domecq.trebolbit.com/"; // pruebas
export const PageWebUrl = "http://localhost:8080/"; // desarrollo

export default ApiUrl;
